<template>
    <b-alert variant="danger" show>{{ message }}</b-alert>
</template>

<script>
export default {
  name: 'Notification',
  props: ['message']
}
</script>